// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBe2fs-8GWWL-6KO4QH8G58bEG1j7Mv-4g",
    authDomain: "kanban-app-fb364.firebaseapp.com",
    databaseURL: "https://kanban-app-fb364.firebaseio.com",
    projectId: "kanban-app-fb364",
    storageBucket: "kanban-app-fb364.appspot.com",
    messagingSenderId: "755958413824",
    appId: "1:755958413824:web:dd8fa73311ede5aa4eb6e5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
